export function LogoX({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="currentColor" aria-hidden="true">
      <path d="M9 7 L20 24 L9 41 H17 L24 30 L31 41 H39 L28 24 L39 7 H31 L24 18 L17 7 Z" />
    </svg>
  );
}
